import React from 'react';
import { LayoutDashboardIcon, LogOutIcon, UsersIcon, TagIcon } from 'lucide-react';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/rvAH9mmpehfrmFnpSd4p81/dashboard.png';
interface SidebarProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
  onLogout: () => void;
}
export function Sidebar({
  activeTab,
  setActiveTab,
  onLogout
}: SidebarProps) {
  const navItems = [{
    id: 'dashboard',
    label: 'Panel Principal',
    icon: LayoutDashboardIcon
  }, {
    id: 'clients',
    label: 'Catálogo de Clientes',
    icon: UsersIcon
  }, {
    id: 'status',
    label: 'Catálogo de Estados',
    icon: TagIcon
  }];
  return <div className="w-64 bg-white border-r border-gray-200 h-screen flex flex-col sticky top-0" data-id="element-95">
      <div className="p-4 flex items-center justify-center border-b border-gray-200" data-id="element-96">
        <img src={LOGO_URL} alt="Dashboard de Control Aperturas y Cierres" className="h-14 w-auto" data-id="element-97" />
      </div>

      <div className="flex-1 py-6 px-4 space-y-1 overflow-y-auto" data-id="element-98">
        {navItems.map(item => {
        const Icon = item.icon;
        const isActive = activeTab === item.id;
        return <button key={item.id} onClick={() => setActiveTab(item.id)} className={`w-full flex items-center space-x-3 px-3 py-2.5 rounded-md transition-colors text-sm font-medium ${isActive ? 'bg-primary/10 text-primary' : 'text-muted-foreground hover:bg-muted hover:text-foreground'}`} data-id="element-99">
              <Icon className={`w-4 h-4 ${isActive ? 'text-primary' : 'text-muted-foreground'}`} data-id="element-100" />
              <span data-id="element-101">{item.label}</span>
            </button>;
      })}
      </div>

      <div className="p-4 border-t border-gray-200" data-id="element-102">
        <button onClick={onLogout} className="w-full flex items-center space-x-3 px-3 py-2.5 rounded-md transition-colors text-sm font-medium text-muted-foreground hover:bg-destructive/10 hover:text-destructive" data-id="element-103">
          <LogOutIcon className="w-4 h-4" data-id="element-104" />
          <span data-id="element-105">Cerrar Sesión</span>
        </button>
      </div>
    </div>;
}